<template>
  <div class="template">
    <div class="search">
      <div>
        <Input
          v-model="search.search"
          placeholder="关键字"
          style="width: 310px; margin-right: 10px"
          icon="ios-search"
        ></Input>
        <Button style="width: 90px" type="primary" icon="ios-search" @click="searchFn">搜索</Button>
      </div>
      <Button type="primary" @click="$router.push({ name: 'add-admin' })">添加管理员</Button>
    </div>
    <div class="table">
      <Table border :columns="diyData.columns" :data="apiData.tableList">
        <template slot="footer">
          <Page
            :total="apiData.total"
            show-total
            :page-size="apiData.per_page"
            :current="search.page"
            class-name="footer-page"
            @on-change="pageChange"
          ></Page>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
  import * as apiStaff from '@/api/permission/admin'
  export default {
    name: 'admin-manage',
    data() {
      return {
        query: {},
        search: {
          search: '',
          page: 1,
        },
        diyDom: {},
        diyData: {
          columns: [
            {
              title: 'ID',
              render: (h, params) => {
                return h('div', params.index + 1)
              },
            },
            {
              title: '姓名',
              key: 'name',
            },
            {
              title: '账号',
              key: 'mobile',
            },
            {
              title: '状态',
              key: 'status_lab',
            },
            {
              title: '角色',
              key: 'super_str',
            },
            {
              title: '添加时间',
              key: 'created_at',
            },
            {
              title: '操作',
              fixed: 'right',
              width:130,
              render: (h, params) => {
                return h('div', [
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                      },
                      on: {
                        click: () => {
                          this.$router.push({
                            name: 'add-admin',
                            query: {
                              id: params.row.id,
                            },
                          })
                        },
                      },
                    },
                    '编辑'
                  ),
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                      },
                      on: {
                        click: () => {
                          this.$Modal.confirm({
                            title: '提示',
                            content: `请确认是否${params.row.status == 1 ? '停用' : '启用'}当前账号？`,
                            onOk: () => {
                              apiStaff.apiAdminUserUpdateStatus(params.row.id).then(res => {
                                this.$Message.success(`已${params.row.status == 1 ? '停用' : '启用'}`)
                                this.getTableList()
                              })
                            },
                          })
                        },
                      },
                    },
                    params.row.status == 1 ? '停用' : '启用'
                  ),
                  h(
                    'a',
                    {
                      style: {
                        color: 'red',
                      },
                      on: {
                        click: () => {
                          this.$Modal.confirm({
                            title: '提示',
                            content: '请确认是否删除当前数据？',
                            onOk: () => {
                              apiStaff.apiAdminUserDelete(params.row.id).then(res => {
                                this.$Message.success('删除成功')
                                this.getTableList()
                              })
                            },
                          })
                        },
                      },
                    },
                    '删除'
                  ),
                ])
              },
            },
          ],
        },
        apiData: {
          total: 0,
          per_page: 0,
          tableList: [],
        },
      }
    },
    methods: {
      // 获取表格数据
      getTableList() {
        this.$store.commit('setSpinShow', true)
        apiStaff
          .apiAdminUserList({ ...this.search })
          .then(res => {
            const { data, meta } = res
            this.apiData.tableList = data
            this.apiData.total = meta.pagination.total
            this.apiData.per_page = meta.pagination.per_page
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      // 分页
      pageChange(e) {
        this.search.page = e
        this.getTableList()
      },
      // 搜索
      searchFn() {
        this.search.page = 1
        this.getTableList()
      },
      // 清空
      clearFn() {
        console.log('清空')
      },
    },
    mounted() {
      this.getTableList()
    },
  }
</script>

<style scoped lang="less">
  .template {
    .search {
      display: flex;
      justify-content: space-between;
    }
    .table {
      margin-top: 10px;
    }
    .filter {
      margin: 10px 0;
      display: flex;
      justify-content: left;
      align-items: center;
      padding: 6px 0 20px 0;
      flex-wrap: wrap;
      border: 1px solid rgba(237, 237, 237, 1);

      .filter-item {
        margin: 14px 0 0 20px;

        .title {
          margin-right: 10px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(74, 74, 74, 1);
          line-height: 17px;
        }
      }
    }
  }
</style>
